export type PrototypeTarget = "app" | "web" | "url";

export interface Prototype {
  name: string;
  target: PrototypeTarget;
  hasChildren?: boolean;
  prototype: string;
  items?: Prototype[];
}

/** Remote config tile order — sub-item navigation depends on these indices. */
export const MASS_NOTIFICATION_INDEX = 3;
export const INDIVIDUAL_NOTICE_INDEX = 4;
export const INVITATIONS_INDEX = 5;
